import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
    Clock,
    DollarSign,
    Eye,
    Edit,
    Calendar,
    Trash2,
    SearchX
} from 'lucide-react';

const InvitesList = ({ invites, onRevoke, onImpersonate, onEdit, onRenew }) => {
    return (
        <div className="space-y-6">
            <div className="flex flex-col gap-2">
                <h3 className="text-xl font-bold text-white flex items-center gap-2">
                    <Clock className="h-5 w-5 text-blue-400" />
                    Aguardando Assinatura
                </h3>
                <p className="text-gray-400">
                    Prestadores que receberam convite mas ainda não se registraram.
                </p>
            </div>

            <div className="rounded-xl border border-white/10 overflow-hidden bg-white/5">
                <Table>
                    <TableHeader className="bg-black/40">
                        <TableRow className="border-white/5 hover:bg-transparent">
                            <TableHead className="text-gray-400 font-medium py-4">Prestador</TableHead>
                            <TableHead className="text-gray-400 font-medium py-4">Cargo</TableHead>
                            <TableHead className="text-gray-400 font-medium py-4">Detalhes do Contrato</TableHead>
                            <TableHead className="text-right text-gray-400 font-medium py-4">Ações</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {invites.length > 0 ? (
                            invites.map((staff) => (
                                <TableRow key={staff.discordId} className="border-white/5 hover:bg-white/5 transition-colors group">
                                    <TableCell className="font-medium text-white py-4">
                                        <div className="flex flex-col">
                                            <span className="text-lg font-bold group-hover:text-purple-400 transition-colors">{staff.codename || 'Sem codinome'}</span>
                                            <span className="text-xs text-gray-500 font-mono tracking-wide">{staff.discordId}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell className="py-4">
                                        <Badge variant="secondary" className="bg-white/10 text-gray-300 hover:bg-white/20 border border-white/5 px-3 py-1">
                                            {staff.accessLevel}
                                        </Badge>
                                    </TableCell>
                                    <TableCell className="py-4">
                                        <div className="text-sm text-gray-300 flex items-center gap-3">
                                            <div className="flex items-center gap-1.5 bg-green-500/10 px-2 py-1 rounded text-green-400 border border-green-500/20">
                                                <DollarSign className="w-3 h-3" />
                                                {staff.contractValue || '0'}
                                            </div>
                                            <span className="text-gray-700">|</span>
                                            <div className="flex items-center gap-1.5 bg-blue-500/10 px-2 py-1 rounded text-blue-400 border border-blue-500/20">
                                                <Clock className="w-3 h-3" />
                                                {staff.contractDuration} {staff.contractUnit === 'days' ? 'dias' : 'meses'}
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell className="text-right py-4">
                                        <div className="flex items-center justify-end gap-2 text-gray-400 opacity-60 group-hover:opacity-100 transition-all">
                                            <Button
                                                size="icon"
                                                variant="ghost"
                                                className="h-9 w-9 hover:bg-white/10 hover:text-white rounded-lg transition-all"
                                                title="Visualizar Painel"
                                                onClick={() => onImpersonate(staff.discordId)}
                                            >
                                                <Eye className="h-4 w-4" />
                                            </Button>
                                            <Button
                                                size="icon"
                                                variant="ghost"
                                                className="h-9 w-9 hover:bg-yellow-500/20 hover:text-yellow-400 rounded-lg transition-all"
                                                title="Editar Contrato"
                                                onClick={() => onEdit(staff)}
                                            >
                                                <Edit className="h-4 w-4" />
                                            </Button>

                                            <Button
                                                size="icon"
                                                variant="ghost"
                                                className="h-9 w-9 hover:bg-red-500/20 hover:text-red-400 rounded-lg transition-all"
                                                title="Revogar Convite"
                                                onClick={() => onRevoke(staff.discordId)}
                                            >
                                                <Trash2 className="h-4 w-4" />
                                            </Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={4} className="h-32 text-center text-gray-500">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <SearchX className="h-8 w-8 text-gray-700" />
                                        <p>Nenhum contrato aguardando assinatura.</p>
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default InvitesList;
